export const WomenHomepage = require('./womenpic.png');
export const Logo = require('./LOGOFINAL.png');
export const OpenLock = require('./open-lock.png');
export const ClosedLock = require('./locked.png');
